import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

import { changeRate } from "../../store/modules/audio/actions";
import { getRate } from "../../store/modules/audio/selectors";

import { MAX_SPEED, MIN_SPEED } from "../constants/speed";

import { rateToValue, valueToRate } from "../../utils/converSpeed";

enum Operation {
  decrease,
  increase
}
const step = 10; // words

const useSpeed = (operation: Operation) => {
  const dispatch = useDispatch();
  const currentRate = useSelector(getRate);
  const { canDo, newSpeed } = useMemo(() => {
    const currentSpeed = rateToValue(currentRate);

    return operation === Operation.increase
      ? { canDo: currentSpeed < MAX_SPEED, newSpeed: currentSpeed + step }
      : { canDo: currentSpeed > MIN_SPEED, newSpeed: currentSpeed - step }
  }, [operation, currentRate]);

  return useCallback(() => {
    if (canDo) {
      dispatch(changeRate(valueToRate(newSpeed)));
    } else {
      toastr.warning("Speed", "Speed is out of range.");
    }
  }, [canDo, newSpeed, dispatch]);
};

export const useIncreaseSpeed = () => useSpeed(Operation.increase);
export const useDecreaseSpeed = () => useSpeed(Operation.decrease);
